import { render } from "./WorldRadio.vue?vue&type=template&id=34913e53"
import script from "./WorldRadio.vue?vue&type=script&lang=js"
export * from "./WorldRadio.vue?vue&type=script&lang=js"

import "./WorldRadio.vue?vue&type=style&index=0&id=34913e53&lang=css"
script.render = render

export default script